import { Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CancelledSubscriptionInfoModalProps } from '../subscription.types';
import { Trans, useTranslation } from 'react-i18next';
import { capitalize } from '@shared/utils/capitalize';

const CancelledSubscriptionInfoModal = ({ open, onClose, hideModal, purpose }: CancelledSubscriptionInfoModalProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleNavigate = () => {
    hideModal();
    navigate('/settings/subscription');
  };
  return (
    <Modal
      width={400}
      className="text-center "
      classNames={{ content: '!max-w-[420px]' }}
      centered
      open={open}
      onCancel={onClose}
      footer={
        <div className="flex justify-center gap-4 mt-4">
          <Button className="flex-1 capitalize!" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button type="primary" className="flex-1 capitalize!" onClick={handleNavigate}>
            {t('yes')}
          </Button>
        </div>
      }
      zIndex={9999}
    >
      <p className="text-text-900 text-lg font-semibold mb-2">{capitalize(t('subscription_cancelled'))}</p>
      <p className="text-text-500  mb-2">
        <Trans
          i18nKey="subscription_canceled_to_proceed_restore_subscription"
          values={{ purpose }}
          components={[<span key="purpose" className="font-semibold"></span>]}
        />
      </p>
    </Modal>
  );
};

export default CancelledSubscriptionInfoModal;
